const page_rewards = {

  init: () => {

    $(window).on('load', function(){
      update_buttons();
    });

    function update_buttons() {
      console.log('one');
      var svg_arrow =
      '<svg xmlns="http://www.w3.org/2000/svg" class="icon-arrow-right" width="34" viewBox="0 0 33.3 22.16">' +
        '<g id="right-arrow"><path d="M22.22 0L20.4 1.83l8 8H0v2.58h28.36l-8 8 1.82 1.83L33.3 11.08z" fill="#0047ba" /></g>' +
      '</svg>';
      $(svg_arrow).appendTo('button.yotpo-button-style');
      $('button.yotpo-button-style').attr('style', 'opacity: 1');
    }
  }

};
export default page_rewards;
